import COMMON_TOPIC_HEADERS from './commonTopicHeaders'
import TABLE_HEADERS from './tableHeaders'

export default Object.freeze({
  SORT_ORDER: 2,
  URI: '?type=paidFamilyMedicalLeave',
  JSON_VALUE: 'paidFamilyMedicalLeave',
  PRETTY_PRINT: 'Paid Family And Medical Leave',
  TOPICS: {
    ...COMMON_TOPIC_HEADERS,
    JURISDICTION_NAME: {
      HEADER: 'Name',
      ACCESSOR: 'jurisdictionName'
    },
    WEEKS_ALLOWED: {
      HEADER: 'Weeks Allowed',
      ACCESSOR: 'weeksAllowed'
    },
    EFFECTIVE_DATE: {
      HEADER: 'Effective Date',
      ACCESSOR: 'effectiveDate'
    },
    WEEKS_ALLOWED_PER_TYPE_OF_LEAVE: {
      HEADER: 'Weeks Allowed Per Type of Leave',
      ACCESSOR: 'weeksAllowedPerTypeOfLeave'
    },
    WAITING_PERIOD: {
      HEADER: 'Waiting Period',
      ACCESSOR: 'waitingPeriod'
    },
    INTERMITTENT_USE: {
      HEADER: 'Intermittent Use',
      ACCESSOR: 'intermittentUse'
    }
  },
  get CSV_HEADER_ROW_VALUES() {
    return [
      TABLE_HEADERS.JURISDICTION_NAME.HEADER,
      TABLE_HEADERS.JURISDICTION_TYPE.HEADER,
      TABLE_HEADERS.PAID_LEAVE_TYPE.HEADER,
      this.TOPICS.EFFECTIVE_DATE.HEADER,
      this.TOPICS.WEEKS_ALLOWED.HEADER,
      this.TOPICS.WAITING_PERIOD.HEADER,
      this.TOPICS.INTERMITTENT_USE.HEADER
    ]
  }
})
